export default [
  {
    path: '/virtus/visualizadorProcesso',
    name: 'visualizadorProcesso',
    component: () => import(/* webpackChunkName: "virtus" */ './visualizadorProcesso.vue')
  }
]
